<div class="main-container">
  <div class="container-fluid pt-3 mb-3 pb-3">
    <div class="login pt-3 pb-3">
      <div class="login-section">
        <form [formGroup]="signUpForm" (submit)="doRegister()" autocomplete="off">
          <div class="login-form">
            <div class="login-logo">
              <img src="../../../assets/images/refresh-logo.svg" alt="" *ngIf="selectedBusiness == 'REFRESH'">
              <img src="../../../assets/images/zones-logo.svg" alt="" *ngIf="selectedBusiness == 'ZONES'">
              <span>Contractor Portal</span>
            </div>
            <h4 class="text-center">Sign Up</h4>
            <div class="row">
              <!-- <div class="col-md-12 col-sm-12 col-12 mb-4 text-center">
                <mat-radio-group>
                  formControlName="owenership"
                  <mat-radio-button value="Company" class="me-3" checked
                    >Company</mat-radio-button
                  >
                  <mat-radio-button value="Individual"
                    >Individual</mat-radio-button
                  >
                </mat-radio-group>
                <mat-error
                  *ngIf="signUpForm.get('owenership').hasError('required')"
                  >Please choose your ownership</mat-error
                >
              </div> -->
              <!-- <div class="col-md-12 col-sm-12 col-12" *ngIf="companySelected">
                <mat-form-field
                  class="example-form-field full-width"
                  appearance="outline"
                >
                  <mat-label>Company Name</mat-label>
                  <input
                    matInput
                    formControlName="company_name"
                    type="text"
                    required
                  />
                  <mat-error
                    *ngIf="signUpForm.get('company_name').hasError('required')"
                    >Company name is required</mat-error
                  >
                  <mat-error
                    *ngIf="
                      signUpForm.get('company_name').hasError('IsValidName')
                    "
                    >Enter a valid company name</mat-error
                  >
                </mat-form-field>
              </div> -->
              <div class="col-md-12 col-sm-12 col-12">
                <mat-form-field class="example-form-field full-width" appearance="outline">
                  <mat-label>Name</mat-label>
                  <input matInput formControlName="subcontractor_name" type="text" required autocomplete="off" />
                  <mat-error *ngIf="
                      signUpForm.get('subcontractor_name')?.hasError('required')
                    ">Name is required</mat-error>
                  <mat-error *ngIf="
                      signUpForm
                        .get('subcontractor_name')?.hasError('IsValidName')
                    ">Enter a valid name</mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-12 col-sm-12 col-12">
                <mat-form-field class="example-form-field full-width" appearance="outline">
                  <mat-label>Location</mat-label>
                  <mat-select formControlName="country_id"
                    (selectionChange)="setPhonecode($event.value);getCategories($event.value)" required>
                    <mat-option [value]="">Select</mat-option>
                    <mat-option *ngFor="let loc of location" [value]="loc?.country_id">{{ loc?.name }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="signUpForm.get('country_id')?.hasError('required')">Location is required</mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-12 col-sm-12 col-12">
                <div class="row">
                  <div class="col-md-3 col-sm-3 col-3 pe-0">
                    <mat-form-field class="example-form-field full-width country-code" appearance="outline">
                      <!-- <mat-label>Country Code</mat-label> -->
                      <mat-select formControlName="phone_code" required>
                        <mat-option value="">Select</mat-option>
                        <mat-option *ngFor="let loc of location" [value]="loc?.phone_code">{{ loc?.phone_code
                          }}</mat-option>
                      </mat-select>
                      <mat-error class="" *ngIf="
                          signUpForm.get('phone_code')?.hasError('required')
                        ">Country code is required</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 col-sm-6 col-5 pe-0">
                    <mat-form-field class="example-form-field full-width" appearance="outline">
                      <mat-label>Phone</mat-label>
                      <input matInput formControlName="mobile" maxlength="15" autocomplete="off" type="tel" required
                        autocomplete="off" [readonly]="!enableMobile"/>
                      <mat-error *ngIf="signUpForm.get('mobile')?.hasError('required')">Mobile Number is
                        required</mat-error>
                      <mat-error *ngIf="
                          signUpForm
                            .get('mobile')?.hasError('invalidMobileNumber')
                        ">Enter a valid mobile number</mat-error>
                      <!-- <mat-error *ngIf="signUpForm.get('mobile').hasError('invalidMobileNumber')"> Invalid Phone no</mat-error> -->
                    </mat-form-field>
                  </div>
                  <div class="col-md-3 col-sm-3 col-4">
                    <div class="d-inline-flex">
                      <button mat-raised-button color="primary" *ngIf="!isMobileVerified && !isMobileTimerEnable"
                        type="button" (click)="getMobileOtp()" class="otp" [disabled]="disableMobileOtp">
                        Get OTP
                      </button>
                      <span class="ps-1 pt-1" *ngIf="isMobileVerified">
                        <mat-icon (click)="enableMobileEdit()">edit</mat-icon>
                      </span>
                      <span class="ps-1 pt-1" *ngIf="isMobileVerified">
                        <mat-icon class="bg-success success">check</mat-icon>
                      </span>
                      <span *ngIf="isMobileTimerEnable" class="otp-count">{{
                        mobileTimerText
                        }}</span>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-4 col-4 pe-0">
                    <mat-form-field class="example-form-field full-width"
                      *ngIf="!isMobileVerified && isMobileTimerEnable" appearance="outline">
                      <mat-label>OTP</mat-label>
                      <input matInput formControlName="mobileOtp" maxlength="6" type="password" autocomplete="off"
                        (keypress)="validateNo($event)" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-3 col-sm-3 col-3" *ngIf="!isMobileVerified && isMobileTimerEnable">
                    <button mat-raised-button type="button" (click)="VerifiedMobileOTP()" class="otp bg-warning">
                      Verify
                    </button>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div *ngIf="!isSSOVerified" class="row">
                  <div class="col-md-8 col-sm-8 col-8 pe-0">
                    <mat-form-field class="example-form-field full-width" appearance="outline">
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="email" autocomplete="off" maxlength="50" type="text" required />
                      <mat-error *ngIf="signUpForm.get('email')?.hasError('required')">Email is required</mat-error>
                      <mat-error *ngIf="
                          signUpForm.get('email')?.hasError('email') &&
                          !signUpForm.get('email')?.hasError('required')
                        ">Enter a valid email</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-md-4 col-sm-4 col-4">
                    <div class="d-inline-flex">
                      <button mat-raised-button color="primary" type="button"
                        *ngIf="!isEmailVerified && !isEmailTimerEnable" (click)="getEmailOtp()" class="otp"
                        [disabled]="disableEmailOtp">
                        Get OTP
                      </button>
                      <div class="ps-1 pt-1" *ngIf="isEmailVerified">
                        <mat-icon class="bg-success success">check</mat-icon>
                      </div>

                      <span *ngIf="isEmailTimerEnable" class="otp-count">{{
                        emailTimerText
                        }}</span>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-4 col-4 pe-0">
                    <mat-form-field class="example-form-field full-width" *ngIf="!isEmailVerified && isEmailTimerEnable"
                      appearance="outline">
                      <mat-label>OTP</mat-label>
                      <input matInput formControlName="emailOtp" maxlength="6" type="password" autocomplete="off"
                        (keypress)="validateNo($event)" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-3 col-sm-3 col-3" *ngIf="!isEmailVerified && isEmailTimerEnable">
                    <button mat-raised-button type="button" class="otp bg-warning" (click)="VerifiedEmailOTP()">
                      Verify
                    </button>
                  </div>
                </div>
                <div class="row" *ngIf="isSSOVerified">
                  <div class="col-md-8 col-sm-8 col-8 pe-0">
                    <mat-form-field class="example-form-field full-width" appearance="outline">
                      <mat-label>Email</mat-label>
                      <input matInput value="{{ signUpForm.get('email')?.value }}" type="text" disabled
                        autocomplete="off" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-4 col-sm-4 col-4">
                    <div class="d-inline-flex">
                      <div class="ps-1 pt-1" *ngIf="isEmailVerified">
                        <mat-icon class="bg-success success">check</mat-icon>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-4 col-4 pe-0">
                    <mat-form-field class="example-form-field full-width" *ngIf="!isEmailVerified" appearance="outline">
                      <mat-label>OTP</mat-label>
                      <input matInput formControlName="emailOtp" maxlength="6" autocomplete="off" type="password" />
                    </mat-form-field>
                  </div>
                  <div class="col-md-3 col-sm-3 col-3" *ngIf="!isEmailVerified">
                    <button mat-raised-button type="button" class="otp bg-warning" (click)="VerifiedEmailOTP()">
                      Verify
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-sm-12 col-12">
                <mat-form-field class="example-form-field full-width" appearance="outline">
                  <mat-label>Trade Category</mat-label>
                  <mat-select formControlName="contractor_type_id" required>

                    <mat-option *ngFor="let cat of category" [value]="cat?.contractor_type_id">{{
                      cat?.contractor_type_name }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="
                      signUpForm.get('contractor_type_id')?.hasError('required')
                    ">Category is required</mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-12 col-sm-12 col-12">
                <mat-form-field class="example-form-field full-width" appearance="outline">
                  <mat-label>Password</mat-label>
                  <input matInput formControlName="password" autocomplete="off" type="password" required
                    (keyup)="passwordstrength()" />
                  <mat-error *ngIf="signUpForm.get('password')?.hasError('required')">Password is required</mat-error>
                  <mat-error *ngIf="signUpForm.get('password')?.hasError('isPassword')">Minimum six characters, at least
                    one uppercase, one
                    lowercase, one number and one special character</mat-error>
                  <mat-hint *ngIf="strengthMsg" [ngStyle]="{ color: msgColor }">{{ strengthMsg }}</mat-hint>
                </mat-form-field>
              </div>
              <div class="col-md-12 col-sm-12 col-12">
                <mat-form-field class="example-form-field full-width" appearance="outline">
                  <mat-label>Confirm Password</mat-label>
                  <input matInput formControlName="confirm_password" type="password" autocomplete="off" required />
                  <mat-error *ngIf="
                      signUpForm.get('confirm_password')?.hasError('required')
                    ">Confirm Password is required</mat-error>
                  <mat-error *ngIf="
                      signUpForm
                        .get('confirm_password')?.hasError('NoPassswordMatch')
                    ">Password does not match</mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-12 col-sm-12 col-12">
                <div class="captcha">
                  <span class="me-2">
                    <canvas class="canva " #canvas width="120px" height="40px"></canvas>
                  </span>
                  <span class="captch-refresh pt-2"><mat-icon (click)="refreshCaptcha()">cached</mat-icon></span>
                </div>
              </div>
              <div class="col-md-12 col-sm-12 col-12">
                <div class="text-label">
                  <mat-form-field class="full-width">
                    <mat-label>Enter Captcha Code</mat-label>
                    <input type="text" formControlName="captcha" matInput autocomplete="off" required>
                    <mat-error *ngIf="signUpForm.get('captcha')?.hasError('required')">Captcha
                      is
                      required</mat-error>
                    <mat-error *ngIf="signUpForm.controls['captcha'].errors?.['MustMatch']">Invaild
                      Captcha!</mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-12 col-sm-12 col-12">
                <mat-checkbox class="example-margin" formControlName="is_terms_accepted">I agree
                  <span class="link" (click)="openDialog()">Terms & Conditions</span></mat-checkbox>
                <mat-error *ngIf="
                    signUpForm.get('is_terms_accepted')?.hasError('required') &&
                    isSubmitted
                  ">Terms & Conditions are required</mat-error>
              </div>
              <div class="col-md-12 col-sm-12 col-12 mt-3">
                <button mat-raised-button color="primary" type="submit" class="full-width">
                  Signup
                </button>
              </div>
              <div class="col-md-12 col-sm-12 col-12">
                <div class="separator">
                  <span>Or</span>
                </div>
              </div>
              <!-- <div class="col-md-12">
                            <div class="google">
                                <img src="../../../assets/images/g-logo.png">
                                <span>Continue with Google</span>
                            </div>
                        </div> -->
              <div class="col-md-12 col-sm-12 col-12" (click)="navigateLogin()">
                <p class="signup-btn">Already a User? <span>Login</span></p>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>